import { ATTRIBUTE } from './attributes';

export const ZONE_TYPE = {
    SECTOR: 30,
    VMI: 31,
    AISLE: 32,
    CABINET: 33,
    DRAWER: 34,
    RACK: 35,
    SHELF: 36,
    BIN: 37,
    VENDING_MACHINE: 38,
    VM_COLUMN: 39,
    VM_BIN: 40,
    WALL: 41
}

export const ZONE_ATTR = {
    UNIT_OF_MEASURE: ATTRIBUTE.UNIT_OF_MEASURE,
    RESPONSIBILITY_CENTER: ATTRIBUTE.RESPONSIBILITY_CENTER
}

export const ZONE_RESPONSIBILITY_CENTER_OPTIONS = [
    { id: "SOR", name: "SOR" },
    { id: "HSP", name: "HSP" },
    { id: "LAB", name: "LAB" },
    { id: "SI", name: "SI" },
    { id: "QC", name: "QC" },
  ]

export const ZONE_TYPES_WITH_MULTI_CREATE = [
    ZONE_TYPE.CABINET,
    ZONE_TYPE.DRAWER,
    ZONE_TYPE.RACK,
    ZONE_TYPE.SHELF,
    ZONE_TYPE.BIN,
    ZONE_TYPE.VM_COLUMN,
    ZONE_TYPE.VM_BIN,
    ZONE_TYPE.WALL
]

export const ZONE_TYPES_WITH_EDITABLE_NAMES = [
    ZONE_TYPE.CABINET,
    ZONE_TYPE.DRAWER,
    ZONE_TYPE.RACK,
    ZONE_TYPE.SHELF,
    ZONE_TYPE.BIN,
    ZONE_TYPE.VM_COLUMN,
    ZONE_TYPE.VM_BIN,
    ZONE_TYPE.WALL
]

export const ZONE_TYPES_WITH_BULK_BIN_LABEL_PRINT = [
    ZONE_TYPE.DRAWER,
    ZONE_TYPE.SHELF,
    ZONE_TYPE.WALL
]

export const ZONE_TYPES_WITH_INVENTORY_ICON = [
    ZONE_TYPE.DRAWER,
    ZONE_TYPE.SHELF,
    ZONE_TYPE.BIN,
    ZONE_TYPE.VM_BIN,
    ZONE_TYPE.WALL
]